// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Hjla3","content":"styles_content__wyg6M"};